import { THIS_YEAR } from '../components/generic/date-range-picker/date-range-picker.vue';

export default {
    namespaced: true,
    state() {
        return {
            properties: [],
            cleaners: [],
            showBlocks: false,
            showSameDayTurnoversOnly: false,
            showDisabledProperties: false,
        };
    },
    getters: {
        properties: state => state.properties,
        cleaners: state => state.cleaners,
        showBlocks: state => state.showBlocks,
        showSameDayTurnoversOnly: state => state.showSameDayTurnoversOnly,
        showDisabledProperties: state => state.showDisabledProperties,
    },
    mutations: {
        setYear(state, year) {
            state.year = year;
        },
        setProperties(state, properties) {
            state.properties = properties;
        },
        setCleaners(state, cleaners) {
            state.cleaners = cleaners;
        },
        setShowBlocks(state, showBlocks) {
            state.showBlocks = showBlocks;
        },
        setShowSameDayTurnoversOnly(state, showSameDayTurnoversOnly) {
            state.showSameDayTurnoversOnly = showSameDayTurnoversOnly;
        },
        setShowDisabledProperties(state, showDisabledProperties) {
            state.showDisabledProperties = showDisabledProperties;
        },
    },
    actions: {
        async changeYear({ commit }, value) {
            commit('setYear', value);
        },
        async changeProperties({ commit }, value) {
            commit('setProperties', value);
        },
        async changeCleaners({ commit }, value) {
            commit('setCleaners', value);
        },
        async changeShowBlocks({ commit }, value) {
            commit('setShowBlocks', value);
        },
        async changeShowSameDayTurnoversOnly({ commit }, value) {
            commit('setShowSameDayTurnoversOnly', value);
        },
        async changeShowDisabledProperties({ commit }, value) {
            commit('setShowDisabledProperties', value);
        },
    },
};
